<template>
	<header-menu-admin />

	<section class="error-section py-40" v-if="!product && !loading">
		<div class="container-fluid">
			<div class="error-wrapper text-center py-40 bg-white br-10">
				<h1 class="mb-32">404</h1>
				<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
				<p class="light-gray mb-32">Товар не найден.<br/>Возможно он был удален либо никогда не существовал.</p>
				<router-link :to="{path: '/admin/products'}" class="cus-btn">В список товаров</router-link>
			</div>
		</div>
	</section>
	
	<div v-else>
		<!-- Main Sections -->
		<main class="main-wrapper bg-lightest-gray">

			<!-- About Section Start -->
			<section class="about-section py-40">
				<div class="container-fluid">
					<div class="top-bar mb-16">
						<router-link :to="{path: '/admin/products'}" class="btn btn-secondary">
							Назад
						</router-link>
					</div>
					<div class="about-wrapper bg-white mb-3">
						<div class="about-block">
							<h4 class="mb-12">Изменение товара</h4>
							<form @submit.prevent="onProductEdit" class="contact-form">
								<div class="row">
									<div class="col-md-1">
										<div class="input-block mb-16">
											<label for="id" class="form-label">ID товара:</label>
											<input type="number" id="id" class="form-control" :value="product?.id" disabled>
										</div>
									</div>
									<div class="col-md-11">
										<div class="input-block mb-16">
											<label for="name" class="form-label">Название товара:</label>
											<input type="text" id="name" class="form-control" placeholder="Название товара" v-model="name" required>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<label for="oldPrice" class="form-label">Старая цена товара:</label>
											<input type="number" id="oldPrice" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="oldPrice">
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<label for="price" class="form-label">Текущая цена товара:</label>
											<input type="number" id="price" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="price">
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<label for="category_id" class="form-label">Категория товара:</label>
											<select id="category_id" class="form-select" v-model="category_id" required>
												<option :value="cat.id" v-for="cat in appModel.productsCategories" :key="cat.id">{{cat.name}}</option>
											</select>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<label for="description" class="form-label">Описание товара:</label>
											<textarea id="description" cols="8" rows="5" class="form-control" placeholder="Описание товара" v-model="description" required></textarea>
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Сохранить изменения</button>
									</div>
									<div class="col-md-6 text-end">
										<button type="button" class="btn btn-outline-danger" @click="onDelete">Удалить</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
					<div class="about-wrapper bg-white">
						<div class="about-block">
							<h4 class="mb-12">Изображения товара</h4>
							<div class="row">
								<div class="col-md-2" v-for="image in product?.images" :key="image.id">
									<div class="card h-100">
										<img :src="'/'+image.path" class="card-img-top" alt="">
										<div class="card-body text-center">
											<button type="button" class="btn btn-sm btn-primary me-2" @click="onSetPoster(image.id)" v-if="!image.isPoster">
												Сделать постером
											</button>
											<button type="button" class="btn btn-sm btn-danger" @click="onDeleteImage(image.id)" v-if="!image.isPoster">
												<svg width="20" height="20" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
											</button>
											<div v-if="image.isPoster">Постер</div>
										</div>
									</div>
								</div>
							</div>
							<div class="hr-line my-3"></div>
							<form @submit.prevent="onUploadImage">
								<div class="row">
									<div class="col-md-12">
										<div class="input-block">
											<label for="poster" class="form-label">Загрузить изображение:</label>
											<div class="input-group">
												<input type="file" id="poster" class="form-control d-block" @change="handleFileChange">
												<button type="submit" class="btn btn-primary" :disabled="btnDisabledUpload">Загрузить</button>
											</div>
										</div>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="errorImages">
								{{errorImages}}
								<button type="button" class="btn-close" aria-label="Close" @click="errorImages = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- About Section End -->
		</main>
		<!-- Main Sections -->
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		product: null,
		category_id: '',
		name: '',
		oldPrice: '',
		price: '',
		description: '',
		
		poster: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
		
		errorImages: '',
		btnDisabledUpload: false,
	}),
	methods: {
		handleFileChange(event){
			this.poster = event.target.files[0];
		},
		
		async loadProduct(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetProduct(this.$route.params.id);
			if(ret.success){
				this.product = ret.item;
				this.category_id = this.product?.category_id||'';
				this.name = this.product?.name||'';
				this.oldPrice = this.product?.oldPrice||'';
				this.price = this.product?.price||'';
				this.description = this.product?.description||'';
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		async onProductEdit(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				category_id: this.category_id,
				name: this.name,
				oldPrice: this.oldPrice,
				price: this.price,
				description: this.description,
			};
			const ret = await this.appModel.doEditProduct(this.$route.params.id, params);
			this.btnDisabled = false;
			if(ret.success){
				
			} else {
				this.error = ret.error;
			}
		},
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данный товар?')){
				const ret = await this.appModel.doDeleteProduct(this.$route.params.id);
				if(ret.success){
					this.$router.push('/admin/products');
				} else {
					alert(ret.error);
				}
			}
		},
		async onUploadImage(){
			this.errorImages = '';
			this.btnDisabledUpload = true;
			
			const params = {
				poster: this.poster,
			};
			let ret = await this.appModel.doAddProductImage(this.$route.params.id, params);
			this.btnDisabledUpload = false;
			if(ret.success){
				this.poster = null;
				
				ret = await this.appModel.doGetProductImages(this.$route.params.id);
				if(ret.success){
					this.product.images = ret.images;
				}
			} else {
				this.errorImages = ret.error;
			}
		},
		async onSetPoster(id){
			this.errorImages = '';
			
			let ret = await this.appModel.doSetProductPoster(this.$route.params.id, id);
			if(ret.success){
				ret = await this.appModel.doGetProductImages(this.$route.params.id);
				if(ret.success){
					this.product.images = ret.images;
				}
			} else {
				this.errorImages = ret.error;
			}
		},
		async onDeleteImage(id){
			if(confirm('Вы уверены, что хотите удалить данное изображение?')){
				this.errorImages = '';
				
				let ret = await this.appModel.doDeleteProductImage(this.$route.params.id, id);
				if(ret.success){
					ret = await this.appModel.doGetProductImages(this.$route.params.id);
					if(ret.success){
						this.product.images = ret.images;
					}
				} else {
					this.errorImages = ret.error;
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadProduct();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>